// WooZoo EN -> FR dictionary, ported verbatim from the approved mockup's i18n.js.
// Keys are the exact English source strings as written in the markup; in FR mode
// t(en) returns the mapped value, otherwise the original string is kept.

export const DICT: Record<string, string> = {
    // NAV / MENU ---------------------------------------------------------
    "Context": "Contexte",
    "Gaze": "Regard",
    "Experience": "Expérience",
    "Identity": "Identité",
    "When": "Quand",
    "Ethics": "Éthique",
    "Pricing": "Tarifs",
    "Contact": "Contact",
    "Menu": "Menu",
    "WooZoo Business": "WooZoo Business",
    "Get the app": "Téléchargez l'app",
    "→ App Store": "→ App Store",
    "→ Google Play": "→ Google Play",
    "For organizations": "Pour les organisations",
    "→ WooZoo Business": "→ WooZoo Business",
    "Follow": "Suivez-nous",
    "→ Instagram": "→ Instagram",

    // HERO ---------------------------------------------------------------
    "Public digital identity · revealed": "Identité numérique publique · révélée",
    // Hero headline kept in English in both languages — no entries for "Know" / "who's" / "who."
    "WooZoo reveals a person's public digital identity — clear, objective, structured. Nothing invented. Nothing interpreted.":
      "WooZoo révèle l'identité numérique publique d'une personne — claire, objective, structurée. Rien d'inventé. Rien d'interprété.",
    "Download on the": "Télécharger sur",
    "App Store": "l'App Store",
    "Get it on": "Disponible sur",
    "Google Play": "Google Play",

    // CONTEXT (01) -------------------------------------------------------
    "01 · The Context": "01 · Le contexte",
    "We have access to everything.": "Nous avons accès à tout.",
    "Except a clear gaze on the people we are about to meet, hire, or invest in.":
      "Sauf à un regard clair sur les personnes que nous nous apprêtons à rencontrer, recruter ou avec qui investir.",
    "Career path": "Parcours professionnel",
    "Press articles": "Articles de presse",
    "Publications": "Publications",
    "Hobbies & passions": "Hobbies & passions",
    "Education": "Formation",
    "Public profiles": "Profils publics",
    "Awards & mandates": "Distinctions & mandats",
    "Yet on people — we still walk in": "Pourtant sur les personnes — nous avançons encore à l'",
    "blind": "aveugle",

    // GAZE (02) ----------------------------------------------------------
    "02 · A Clear Gaze": "02 · Un regard clair",
    "No opinion. No interpretation.": "Pas d'opinion. Pas d'interprétation.",
    "WooZoo relies exclusively on publicly available information and verifiable sources.":
      "WooZoo s'appuie exclusivement sur des informations publiquement disponibles et des sources vérifiables.",
    "No self-declared claims": "Pas de déclarations sur soi-même",
    "No rumors": "Pas de rumeurs",
    "No fabricated content": "Pas de contenu fabriqué",
    "WooZoo creates nothing.": "WooZoo ne crée rien.",
    "It reveals and structures what already exists.": "Il révèle et structure ce qui existe déjà.",

    // iPhone screen content (source is in French - we map FR → EN here, and the runtime swaps either direction)
    "Document privé": "Private document",
    "Musicien légendaire, ex-Beatles,": "Legendary musician, former Beatle,",
    "entrepreneur et activiste": "entrepreneur and environmental",
    "environnemental": "activist",
    "Investisseur tech, fondateur de": "Tech investor, founder of",
    "Vortex Capital, conseiller": "Vortex Capital, strategic",
    "stratégique": "advisor",
    "Founder & CEO at CarJager": "Fondateur & CEO de CarJager",
    "(Barnes CarJager) · Owner at": "(Barnes CarJager) · Propriétaire de",
    "Prieuré de Conil · Founder at WooZoo": "Prieuré de Conil · Fondateur de WooZoo",
    "40-45 ans": "Ages 40–45",
    "40 ans": "Age 40",
    "50-55 ans": "Ages 50–55",
    "Tribes": "Tribus",
    "Art Tribe": "Tribu Art",
    "Tech Tribe": "Tribu Tech",
    "Business Tribe": "Tribu Business",
    "Engagement Tribe": "Tribu Engagement",
    "Hospitality Tribe": "Tribu Hospitality",
    "Statut officiel": "Official status",
    "Lien public": "Public link",
    "Aperçu": "Preview",
    "SYNTHÈSE DE L'ENQUÊTE": "INVESTIGATION SUMMARY",
    "\"Directeur de MPL Communications Ltd (Musique et édition). Actionnaire et administrateur de Apple Corps Ltd (The Beatles). Partenariat stratégique avec LVMH via sa fille Stella McCartney (Conseiller environnemental)…\"":
      "\"Director of MPL Communications Ltd (Music & Publishing). Shareholder and director of Apple Corps Ltd (The Beatles). Strategic partnership with LVMH via his daughter Stella McCartney (Environmental advisor)…\"",
    "\"Fondateur et CEO de Vortex Capital (fonds d'investissement tech). Membre du conseil d'administration de Synapse Robotics SA. Conseiller stratégique auprès de la Fondation Helvetia pour l'innovation. Co-auteur du rapport européen sur la souveraineté numérique (2024)…\"":
      "\"Founder and CEO of Vortex Capital (tech investment fund). Board member of Synapse Robotics SA. Strategic advisor to the Helvetia Foundation for Innovation. Co-author of the European report on digital sovereignty (2024)…\"",
    "\"Founder and CEO of CarJager (Barnes CarJager), the reference marketplace for classic and collection cars. Owner of Prieuré de Conil, a viticultural estate. Founder of WooZoo, the public digital identity platform…\"":
      "\"Fondateur et CEO de CarJager (Barnes CarJager), la marketplace de référence pour les voitures de collection. Propriétaire du Prieuré de Conil, domaine viticole. Fondateur de WooZoo, la plateforme d'identité numérique publique…\"",
    "Member of Barnes International network": "Membre du réseau Barnes International",
    "Entrepreneur in residence — automotive heritage": "Entrepreneur en résidence — patrimoine automobile",
    "Founder of multiple ventures since 2015": "Fondateur de plusieurs entreprises depuis 2015",
    "Formateur référencé chez MA Formation": "Trainer listed with MA Formation",
    "Lauréat du Prix Thinkerview (2018)": "Winner of the Thinkerview Prize (2018)",
    "Président de la SASU": "President of the SASU",
    "Historique": "History",
    "Recherche": "Search",
    "Profil": "Profile",
    "Verified sources": "Sources vérifiées",

    // EXPERIENCE (03) ----------------------------------------------------
    "03 · The Experience": "03 · L'expérience",
    "Two perspectives.": "Deux perspectives.",
    "One gaze.": "Un seul regard.",
    "Reveal your own digital imprint, or read someone else's — same clarity, same structure.":
      "Révélez votre propre empreinte numérique, ou lisez celle d'un autre — même clarté, même structure.",
    "For You": "Pour vous",
    "Start with yourself": "Commencez par vous-même",
    "Enter your name": "Entrez votre nom",
    "Claim your profile": "Revendiquez votre profil",
    "WooZoo reveals your public imprint": "WooZoo révèle votre empreinte publique",
    "Submit authoritative sources to complete it": "Soumettez des sources fiables pour le compléter",
    "Share your card — as a structured signature": "Partagez votre carte — comme une signature structurée",
    "For Them": "Pour les autres",
    "Read another profile": "Lisez un autre profil",
    "Search by name": "Recherchez par nom",
    "Select the matching profile": "Sélectionnez le profil correspondant",
    "Receive a structured public view": "Recevez une vue publique structurée",
    "Read the synthesis and sources": "Lisez la synthèse et les sources",
    "Decide with context — never blindly": "Décidez avec contexte — jamais à l'aveugle",

    // IDENTITY (04) ------------------------------------------------------
    "04 · Master your digital identity": "04 · Maîtrisez votre identité numérique",
    "Your digital identity": "Votre identité numérique",
    "precedes": "précède",
    "you. It circulates. It informs. It": "vous. Elle circule. Elle informe. Elle",
    "influences": "influence",
    "A · Reveal": "A · Révéler",
    "As it manifests": "Telle qu'elle se manifeste",
    "Clear. Structured. Objective. What is already visible — made legible.":
      "Clair. Structuré. Objectif. Ce qui est déjà visible — rendu lisible.",
    "B · Refine": "B · Affiner",
    "Through real sources": "Par de vraies sources",
    "Submit authoritative references. Verified before integration. Never invented.":
      "Soumettez des références fiables. Vérifiées avant intégration. Jamais inventées.",
    "C · Illuminate": "C · Éclairer",
    "Don't transform": "Ne pas transformer",
    "You do not change reality. You ensure it is complete and well-lit.":
      "Vous ne changez pas la réalité. Vous vous assurez qu'elle est complète et bien éclairée.",
    "\"You do not change reality. You illuminate it.\"":
      "« Vous ne changez pas la réalité. Vous l'éclairez. »",
    "Explore my profile →": "Explorer mon profil →",

    // WHEN (05) ----------------------------------------------------------
    "05 · When to use WooZoo": "05 · Quand utiliser WooZoo",
    "Before you meet.": "Avant de rencontrer.",
    "Before you decide.": "Avant de décider.",
    "A personal encounter": "Une rencontre personnelle",
    "A business meeting": "Une réunion professionnelle",
    "A new partnership": "Un nouveau partenariat",
    "A strategic hire": "Un recrutement stratégique",
    "An investment": "Un investissement",
    "A worldly event": "Un événement mondain",
    "Moving forward without context is navigating without reference.":
      "Avancer sans contexte, c'est naviguer sans repère.",
    "WooZoo illuminates signals already visible —": "WooZoo éclaire les signaux déjà visibles —",
    "like a lighthouse in the night.": "comme un phare dans la nuit.",

    // ETHICS (06) --------------------------------------------------------
    "06 · Transparency & responsibility": "06 · Transparence & responsabilité",
    "It": "Il",
    "observes": "observe",
    ", structures, orders.": ", structure, ordonne.",
    "A · Public only": "A · Public uniquement",
    "We aggregate exclusively publicly available information — rendering visible what is already visible.":
      "Nous agrégeons exclusivement des informations publiquement disponibles — rendant visible ce qui est déjà visible.",
    "B · Regulated": "B · Régulé",
    "In full respect of applicable regulatory frameworks. Always.":
      "Dans le plein respect des cadres réglementaires applicables. Toujours.",
    "C · A clear gaze": "C · Un regard clair",
    "Nothing more. Nothing less.": "Rien de plus. Rien de moins.",

    // PRICING (07) -------------------------------------------------------
    "07 · Pricing": "07 · Tarifs",
    "Pay for what": "Payez pour ce que",
    "you reveal.": "vous révélez.",
    "One credit = one full profile analysis. Unused credits roll over within your billing month.":
      "Un crédit = une analyse complète de profil. Les crédits non utilisés sont reportés sur votre mois de facturation.",
    "One-shot": "Achat unique",
    "Starter": "Starter",
    "one-time": "paiement unique",
    "1 search": "1 recherche",
    "One full profile reveal": "Une révélation de profil complète",
    "Synthesis & sources": "Synthèse & sources",
    "PDF export": "Export PDF",
    "Try a search →": "Essayer une recherche →",
    "Insider": "Insider",
    "/ month": "/ mois",
    "HT / month": "HT / mois",
    "30 searches / month": "30 recherches / mois",
    "Everything in Starter": "Tout dans Starter",
    "Search history": "Historique de recherche",
    "Priority support": "Support prioritaire",
    "Cancel anytime": "Annulation à tout moment",
    "Choose Insider →": "Choisir Insider →",
    "Most popular": "Le plus populaire",
    "Elite": "Elite",
    "100 searches / month": "100 recherches / mois",
    "Everything in Insider": "Tout dans Insider",
    "Prospection contact info": "Coordonnées de prospection",
    "Dedicated support": "Support dédié",
    "Advanced source submissions": "Soumission de sources avancée",
    "Early access to new features": "Accès anticipé aux nouvelles fonctionnalités",
    "Choose Elite →": "Choisir Elite →",
    "Cancel anytime · Secure payment": "Annulation à tout moment · Paiement sécurisé",
    "Secure payment": "Paiement sécurisé",

    // B2B ----------------------------------------------------------------
    "Bring WooZoo to your team — know your customers before the first interaction.":
      "Apportez WooZoo à votre équipe — connaissez vos clients avant la première interaction.",
    "WooZoo Business — structured public-identity intelligence for hiring, partnerships, due-diligence and investor relations.":
      "WooZoo Business — intelligence d'identité publique structurée pour le recrutement, les partenariats, la due diligence et les relations investisseurs.",
    "Discover WooZoo Business →": "Découvrir WooZoo Business →",

    // CONTACT (08) -------------------------------------------------------
    "08 · Contact us": "08 · Nous contacter",
    "Let's talk.": "Parlons.",
    "Press, partnerships, business — drop a note and we'll come back to you.":
      "Presse, partenariats, business — laissez-nous un mot et nous reviendrons vers vous.",
    "Email": "E-mail",
    "Press": "Presse",
    "First name": "Prénom",
    "Last name": "Nom",
    "Subject": "Sujet",
    "General enquiry": "Demande générale",
    "Investors": "Investisseurs",
    "Partnership": "Partenariat",
    "DPO": "DPO",
    "Support": "Support",
    "Message": "Message",
    "Send message →": "Envoyer le message →",
    "Sent ✓": "Envoyé ✓",
    "Sending…": "Envoi…",
    "Thanks — we'll get back to you.": "Merci — nous revenons vers vous.",
    "Something went wrong. Please try again.": "Une erreur est survenue. Réessayez.",
    "Protected by a privacy-friendly anti-bot check.": "Protégé par une vérification anti-robot respectueuse de la vie privée.",

    // COOKIE CONSENT -----------------------------------------------------
    "Cookies": "Cookies",
    "Audience measurement": "Mesure d'audience",
    "Aggregate visit statistics, so we know which pages get read. Nothing is loaded before you agree.": "Des statistiques de fréquentation agrégées, pour savoir quelles pages sont lues. Rien n'est chargé avant votre accord.",
    "Learn more": "En savoir plus",
    "Refuse": "Refuser",
    "Accept": "Accepter",
    "Close": "Fermer",
    "Current choice: accepted": "Choix actuel : accepté",
    "Current choice: refused": "Choix actuel : refusé",

    // FOOTER -------------------------------------------------------------
    "© WooZoo 2026 · A clear gaze": "© WooZoo 2026 · Un regard clair",
    "My data": "Mes données",
    "Legals": "Mentions légales",
    "Help": "Aide",
    "Privacy": "Confidentialité",
  };
